import React from "react";

function Terminos() {
  return (
    <main>
      <div
        style={{ paddingTop: "40px", paddingRight: "8vw", paddingLeft: "8vw" }}
      >
        <h3 align="center">Términos y condiciones</h3>
        <br />
        <br />

        <div class="row">
          <div class="col-xs-12 offset-md-2 col-md-8">
            <ul style={{ listStyle: "none" }}>
              <li style={{ marginBottom: "20px" }}>
                1. El concurso está abierto únicamente para residentes de
                Guadalajara, Jalisco.
              </li>
              <li style={{ marginBottom: "20px" }}>
                2. Para participar, los dueños de los perros deben seguir
                nuestra cuenta de Instagram y publicar una foto de su perro
                etiquetándonos y usando el hashtag del concurso.
              </li>
              <li style={{ marginBottom: "20px" }}>
                3. Las fotos deben ser originales y no deben infringir los
                derechos de autor de terceros.
              </li>
              <li style={{ marginBottom: "20px" }}>
                4. Cada participante puede enviar solo una foto.
              </li>
              <li style={{ marginBottom: "20px" }}>
                5. El ganador será determinado por el número de "Me gusta" que
                reciba su foto en Instagram.
              </li>
              <li style={{ marginBottom: "20px" }}>
                6. El premio es de 25 kg de producto para mascotas y no se puede
                canjear por dinero en efectivo u otro producto.
              </li>
              <li style={{ marginBottom: "20px" }}>
                7. Nos reservamos el derecho de descalificar cualquier
                participante que infrinja estas reglas o que tenga un
                comportamiento inapropiado en las redes sociales.
              </li>
              <li style={{ marginBottom: "20px" }}>
                8. El concurso comienza el 12 de Abril y termina el 20 de Abril.
                El ganador será anunciado en nuestra página web el día 21 de
                Abril.
              </li>
              <li style={{ marginBottom: "20px" }}>
                9. Al participar en el concurso, los concursantes aceptan que su
                foto pueda ser compartida en nuestras redes sociales y otros
                canales de marketing.
              </li>
              <li>
                10. Este concurso no está patrocinado, respaldado ni
                administrado por, o asociado con Instagram.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Terminos;
